var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataOpsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h32.121v32.35H0z"
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32.121v32.35H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.06,
    cy: 16.06,
    r: 16.06,
    style: {
      fill: "#29b5e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.706 10.091a7.566 7.566 0 0 0-.924.728l1.905 1.905a4.473 4.473 0 0 1 1.286-.824 4.578 4.578 0 0 1 1.728-.338 4.481 4.481 0 0 1 4.153 2.777 4.48 4.48 0 0 1 0 3.438 4.499 4.499 0 0 1-4.157 2.782c-.343 0-.657-.034-.958-.091a4.02 4.02 0 0 1-.833-.267 4.443 4.443 0 0 1-.781-.471 7.315 7.315 0 0 1-.752-.657l-5.182-5.182-1.9 1.9 5.181 5.182a9.78 9.78 0 0 0 1.105.952 7.53 7.53 0 0 0 1.215.715c.438.2.895.352 1.376.457.481.105.986.157 1.529.157.976 0 1.9-.195 2.748-.543a7.176 7.176 0 0 0 2.333-1.562 7.206 7.206 0 0 0 1.562-2.334 7.088 7.088 0 0 0 .543-2.747c0-.977-.195-1.901-.543-2.748a7.229 7.229 0 0 0-3.895-3.896 7.115 7.115 0 0 0-2.748-.543 7.23 7.23 0 0 0-1.396.138 7.212 7.212 0 0 0-2.595 1.072Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.415 22.025a7.54 7.54 0 0 0 .924-.728l-1.905-1.905a5.45 5.45 0 0 1-.519.409 4.288 4.288 0 0 1-1.61.667c-.29.057-.586.086-.886.086a4.477 4.477 0 0 1-3.176-1.315 4.485 4.485 0 0 1-.976-1.462 4.48 4.48 0 0 1 .971-4.895 4.499 4.499 0 0 1 3.181-1.32c.343 0 .658.034.958.091.3.062.576.152.833.267.267.123.524.281.781.471.257.191.505.41.753.657l5.181 5.182 1.9-1.9-5.181-5.182a9.217 9.217 0 0 0-1.105-.952 7.53 7.53 0 0 0-1.215-.715c-.438-.2-.89-.352-1.371-.457a7.125 7.125 0 0 0-1.529-.157c-.976 0-1.9.195-2.748.543a7.166 7.166 0 0 0-2.333 1.562 7.213 7.213 0 0 0-1.562 2.333 7.097 7.097 0 0 0-.543 2.748c0 .977.195 1.9.543 2.748a7.229 7.229 0 0 0 3.895 3.896 7.115 7.115 0 0 0 2.748.543 7.14 7.14 0 0 0 2.743-.548 7.621 7.621 0 0 0 1.248-.667Z",
    style: {
      fill: "#24323d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataOpsIcon);
export default __webpack_public_path__ + "static/media/DataOps_icon.afe09b89480370004110fbf07faecf41.svg";
export { ForwardRef as ReactComponent };